// extracted by mini-css-extract-plugin
module.exports = {"tabNavigator":"main_tabNavigator__1kuU2","active":"main_active__1i8T8"};